export default __webpack_public_path__ + "static/media/142.3bc95b89.png";